import { Guid } from '../../../types/guid.type';
import { EntityBase, IEntityBaseInfo } from '../../entity/entitybase';
import { IPersonInfo, PersonInfo } from '../../core/person-info';
import { EquipmentVehicleModelExtension, IEquipmentVehicleModelExtensionInfo } from './equipment-vehicle-model-extension';

export interface IEquipmentModelInfo extends IEntityBaseInfo {
  Label?: string;
  Description?: string;
  BrandUid?: Guid;
  BrandLabel?: string;
  AuthorUid?: Guid;
  Author?: IPersonInfo;
  ModelIndex?: number;
  VehicleModelExtension?: IEquipmentVehicleModelExtensionInfo;
}

export class EquipmentModel extends EntityBase {
  Label?: string;
  Description?: string;
  BrandUid?: Guid;
  BrandLabel?: string;
  AuthorUid?: Guid;
  Author?: PersonInfo;
  ModelIndex?: number;
  VehicleModelExtension?: EquipmentVehicleModelExtension;

  constructor(info: IEquipmentModelInfo) {
    super(info);
    this.Label = info.Label;
    this.Description = info.Description;
    this.BrandUid = info.BrandUid;
    this.BrandLabel = info.BrandLabel;
    this.AuthorUid = info.AuthorUid;
    this.Author = PersonInfo.createInstance(PersonInfo, info.Author);
    this.VehicleModelExtension = info.VehicleModelExtension
      ? new EquipmentVehicleModelExtension(info.VehicleModelExtension)
      : new EquipmentVehicleModelExtension({});
  }

  override title(): string {
    return `Modèle d'équipement : ${this.Label}`;
  }

  override description(): string {
    return this.Description || '';
  }

  getModelStatus(): string {
    return this.IsActive ? 'Actif' : 'Inactif';
  }

  getModelStatusColor(): string {
    return this.IsActive ? 'var(--widget-stat-green)' : 'var(--widget-stat-orange)';
  }

  getModelTypeLabel(): string {
    return 'N/A';
  }

  getModelDescription(): string {
    return this.Description || 'Aucune description';
  }
}
